import {SectionItem} from "./SectionItem";
import {Pages} from "./Pages";

export class PageSection {
    id: number;
    title: string;
    body: string;
    priority: number;
    items: Array<SectionItem> = new Array<SectionItem>();
    pages: Pages;

}